export const configuratorConstants = {
    RecommendedSectionProducts: "RecommendedSectionProducts",
    GroundShape: "GroundShape",
    OuterCorners: "OuterCorners",
    InnerCorners: "InnerCorners",
    BasicElementsProductSelector: "BasicElementsProductSelector",
    PlasticBoardPercentage: "PlasticBoardPercentage",
    SecurityMargin: "SecurityMargin",
    TotalSurfaceArea: "TotalSurfaceArea",
    Perimeter: "Perimeter",
    selectedConfiguratorProducts: "SelectedConfiguratorProducts-",
    selectedCustomConfiguratorProducts: "SelectedCustomConfiguratorProducts-",
    productList: "ProductList",
    edgeHeight: "EdgeHeight",
    InnerWallMasonryType: "InnerWallMasonryType",
    recommendedProductSelected: "RecommendedProductSelected",
    BuildingProductSelector: "BuildingProductSelector",
    PlasterThicknessRange: "PlasterThicknessRange",
    PlasteredIndoorWallSides: "PlasteredIndoorWallSides",
    BuildingConfiguratorautoAddProducts : "1841012;9221000;92148;5540305;5586015;",
    PlasteredIndoorWallSidesNone: "4",
    StepByStepInstructions: "StepByStepInstructions",
    ResetPropertiesOnFloorChange: "TotalFloorArea;FloorJointWidth;FloorWidth;FloorLength;FloorThickness;FloorThicknessCastConcrete;TotalSurfaceArea;",
    FloorType: "FloorType",
    TotalFloorArea: "TotalFloorArea",
    FloorJointWidth: "FloorJointWidth",
    FloorWidth: "FloorWidth",
    FloorLength: "FloorLength",
    FloorThickness: "FloorThickness",
    FloorThicknessCastConcrete: "FloorThicknessCastConcrete",
    GreenhouseProductSelector: "GreenHouseProductSelector",
    ECOProductCookieSuffix: "-ecoproducts",
    MaterialConsumptionFactorOutdoorWall: "MaterialConsumptionFactorOutdoorWall",
    MaterialConsumptionFactorIndoorWall: "MaterialConsumptionFactorIndoorWall",
    BuildingConfiguratorFactors: "MaterialConsumptionFactorOutdoorWall;MaterialConsumptionFactorIndoorWall;",
    MaterialConsumptionFactorExaktOutdoorWall: "MaterialConsumptionFactorExaktOutdoorWall",
    CornerBlockOpeningBlockQuantityFactor: "CornerBlockOpeningBlockQuantityFactor",
    AdjustmentFactorForNormalBlockPassPicker: "AdjustmentFactorForNormalBlockPassPicker",
  };
